import { useIntl } from '@/intl'
import { useState } from 'react'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    mixed: translate({ id: 'order.form.bulk.mixed' }),
    notes: translate({ id: 'orders.edit.field.notes' }),
    invalidNotes: (maxLength: number) =>
      translate({ id: 'orders.edit.validation.maxLength', values: { maxLength } }),
    helperText: translate({ id: 'orders.edit.field.notes.helperText' }),
  }))

  return api
}
